@let segmentStatus = pfSegData.segmentStatus();

<h2>Portfolio Status for {{ portfolioName() }}</h2>
<div #mermaid style="width: 800px; border: 1px solid #ccc; border-width: 1px 0;">
</div>

<p style="width: 800px;">
    @if (segmentStatus === SegmentStatusEnum.Open) {
        The current status is 'open'. All users with access to the LoB and office can edit the account data.
    } @else if (segmentStatus === SegmentStatusEnum.InLocalReview) {
        The current status is 'in local review'. Only the TechEx users can edit or refresh regular account data.
            They can flag accounts as 'needs review', in which case underwriters can review and approve or reject the flagged accounts.
    } @else if (segmentStatus === SegmentStatusEnum.InGlobalReview) {
        The current status is 'in global review'. Only the global TechEx users can edit or refresh regular account data.
            As with local review, they can flag accounts as 'needs review', in which case underwriters can review and approve or reject the flagged accounts.
    } @else {
        The current status is 'approved'. No further changes are allowed.
    }
</p>

<fluent-card class="account-status-stats">
    <div class="card-header">
        <h4>Accounts</h4>
        <div>{{totalAccounts()}}</div>
    </div>

    <div class="card-content">
        <wj-flex-pie #statusChart [bindingName]="'status'" [binding]="'count'"
                     [palette]="GeneraliPieChartPalette" [innerRadius]="0.5"
                     [itemsSource]="chartData" [plotMargin]="15"
                     (dblclick)="onChartClick(statusChart, $event)">
            <wj-flex-chart-legend [position]="Wijmo.Position.Right"></wj-flex-chart-legend>
            <wj-flex-pie-data-label content="{count}" [border]="false" [offset]="-25"
                                    [position]="Wijmo.PieLabelPosition.Inside"></wj-flex-pie-data-label>
        </wj-flex-pie>
    </div>
</fluent-card>

<div class="layout-vbox" style="margin-top: 10px; gap: 10px;" [style.opacity]="statusChangeAllowed() ? 1 : 0.5">
    <div class="toolbar-horizontal">
        <label style="font-weight: bold;">Update Status:</label>
        @let btnDisabled = !this.statusChangeAllowed();
        @if (segmentStatus === SegmentStatusEnum.Open) {
            <fluent-button appearance="primary" (click)="setStatus(SegmentStatusEnum.InLocalReview)" [disabled]="btnDisabled">Approve for Local Review</fluent-button>
        } @else if (segmentStatus === SegmentStatusEnum.InLocalReview) {
            <fluent-button appearance="outline" (click)="setStatus(SegmentStatusEnum.Open)" [disabled]="btnDisabled">Go back to Open</fluent-button>
            <fluent-button appearance="primary" (click)="setStatus(SegmentStatusEnum.InGlobalReview)" [disabled]="btnDisabled">Approve for Global Review</fluent-button>
        } @else if (segmentStatus === SegmentStatusEnum.InGlobalReview) {
            <fluent-button appearance="outline" (click)="setStatus(SegmentStatusEnum.InLocalReview)" [disabled]="btnDisabled">Go back to Local Review</fluent-button>
            <fluent-button appearance="primary" (click)="setStatus(SegmentStatusEnum.Approved)" [disabled]="btnDisabled">Final Approve</fluent-button>
        } @else {
            <fluent-button appearance="outline" (click)="setStatus(SegmentStatusEnum.InGlobalReview)" [disabled]="btnDisabled">Go back to Global Review</fluent-button>
        }
    </div>

    <fluent-field label-position="above">
        <label slot="label">Status Change Comment</label>
        <fluent-textarea slot="input" autofocus resize="both"
                         [attr.readonly]="btnDisabled ? true : undefined"
                         ngDefaultControl [(ngModel)]="statusChangeComment"
                         placeholder="Enter status change comment here..." required="true" autoResize="true">
        </fluent-textarea>
    </fluent-field>

</div>


<h2>Status History</h2>

<div class="status-log-container">
    <table>
        <thead>
        <tr>
            <th class="datetime">Date & Time</th>
            <th class="user">User</th>
            <th class="status">Status</th>
            <th class="comment">Comment</th>
        </tr>
        </thead>
        <tbody>
            @for (status of segmentStatusHistory.value(); track status.id) {
                <tr>
                    <td class="datetime">{{AppFormat.formatDateTime(status.createdAt)}}</td>
                    <td class="user">{{status.createdBy}}</td>
                    <td class="status">{{status.status}}</td>
                    <td class="comment">{{status.comment}}</td>
                </tr>
            }
            @if (segmentStatusHistory.value().length === 0) {
                <tr><td colspan="4">No status history yet</td></tr>
            }
        </tbody>
    </table>
</div>
